export default __webpack_public_path__ + "static/media/folder.f531b822.png";